/**
 * @file コンポーネント：フル動画ページスレッドポップアップ ロジック管理
 */

// ライブラリ読み込み
import React, { useEffect, useRef, useState } from "react";

import { fnGetCultureLanguage } from "~/src/functions/common";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const PopupThread = (props) => {
    /**
     * 変数
     */
    const userLanguage = fnGetCultureLanguage(); // 表示言語

    /**
     * 状態管理
     */
    const [currentPage, setCurrentPage] = useState("list"); // 現在表示しているページ
    const [errorMessageList, setErrorMessageList] = useState(null); // スレッド一覧ページに表示するエラーメッセージ
    const [messageDetail, setMessageDetail] = useState(null); // 詳細ページに表示するメッセージ
    const [messageList, setMessageList] = useState(null); // スレッド一覧ページに表示するメッセージ
    const [popupHeadline, setPopupHeadline] = useState(null); // ポップアップ見出し
    const [selectedThread, setSelectedThread] = useState(null); // 選択中のスレッド

    /**
     * 要素参照
     */
    const refPopupContent = useRef(null);

    /**
     * ポップアップがクローズされた時の処理
     */
    useEffect(() => {
        setCurrentPage("list");
        setErrorMessageList(null);
        setMessageDetail(null);
        setMessageList(null);
        setPopupHeadline(null);
    }, [props.isOpenPopupThread]);

    /**
     * 日時を○○前表示する
     * @param {Date} datetime
     * @param {String} language
     */
    const fnGetDatetimeAgo = (datetime, language = userLanguage) => {
        let arrayTimeUnit;
        if (language === "ja") {
            // 日本語単位
            arrayTimeUnit = {
                day: "日前",
                days: "日前",
                hour: "時間前",
                hours: "時間前",
                justnow: "たった今",
                minute: "分前",
                minutes: "分前",
                month: "ヵ月前",
                months: "ヵ月前",
                year: "年前",
                years: "年前",
            };
        } else {
            // 英語単位
            arrayTimeUnit = {
                day: " days ago",
                days: " days ago",
                hour: " hours ago",
                hours: " hours ago",
                justnow: "Just now",
                minute: " minutes ago",
                minutes: " minutes ago",
                month: " months ago",
                months: " months ago",
                year: " years ago",
                years: " years ago",
            };
        }
        // 何秒後か（サーバーレスポンスの時間はUTCなので、その分を考慮）
        const secondsAgo =
            Math.floor(
                (new Date().valueOf() - new Date(datetime).valueOf()) / 1000
            ) +
            new Date().getTimezoneOffset() * 60;
        // 年単位
        const yearsAgo = secondsAgo / (60 * 60 * 24 * 365);
        if (yearsAgo >= 2) {
            return Math.floor(yearsAgo) + arrayTimeUnit.years;
        } else if (yearsAgo >= 1) {
            return Math.floor(yearsAgo) + arrayTimeUnit.year;
        } else {
            // 月単位
            const monthsAgo = secondsAgo / (60 * 60 * 24 * 12);
            if (monthsAgo >= 2) {
                return Math.floor(monthsAgo) + arrayTimeUnit.months;
            } else if (monthsAgo >= 1) {
                return Math.floor(monthsAgo) + arrayTimeUnit.month;
            } else {
                // 日単位
                const daysAgo = secondsAgo / (60 * 60 * 24);
                if (daysAgo >= 2) {
                    return Math.floor(daysAgo) + arrayTimeUnit.days;
                } else if (daysAgo >= 1) {
                    return Math.floor(daysAgo) + arrayTimeUnit.day;
                } else {
                    // 時間単位
                    const hoursAgo = secondsAgo / (60 * 60);
                    if (hoursAgo >= 2) {
                        return Math.floor(hoursAgo) + arrayTimeUnit.hours;
                    } else if (hoursAgo >= 1) {
                        return Math.floor(hoursAgo) + arrayTimeUnit.hour;
                    } else {
                        // 分単位
                        const minutesAgo = secondsAgo / 60;
                        if (minutesAgo >= 2) {
                            return (
                                Math.floor(minutesAgo) + arrayTimeUnit.minutes
                            );
                        } else if (hoursAgo >= 1) {
                            return Math.floor(hoursAgo) + arrayTimeUnit.minutes;
                        } else {
                            // 分未満
                            return arrayTimeUnit.justnow;
                        }
                    }
                }
            }
        }
    };

    // Presenterに渡す
    return (
        <Presenter
            {...props}
            currentPage={currentPage}
            errorMessageList={errorMessageList}
            fnGetDatetimeAgo={fnGetDatetimeAgo}
            messageDetail={messageDetail}
            messageList={messageList}
            popupHeadline={popupHeadline}
            refPopupContent={refPopupContent}
            selectedThread={selectedThread}
            setCurrentPage={setCurrentPage}
            setErrorMessageList={setErrorMessageList}
            setMessageDetail={setMessageDetail}
            setMessageList={setMessageList}
            setPopupHeadline={setPopupHeadline}
            setSelectedThread={setSelectedThread}
        />
    );
};
